import { faInfoCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Field } from "formik";
import { isEmpty } from "lodash";
import moment from "moment";
import React from "react";
import {
  DatePicker,
  FieldButtonGroup,
  FieldDropSide,
  FieldInputDollar,
  SearchableList,
} from "../../../components";
import {
  clearFieldValues,
  OPTIONS_DATA_MAPPER,
  returnOnlyIfBoolean,
  toOptionValuesFromMapper,
  usDateFormat,
  yesNoOptions,
} from "../../../utils";
import {
  calculateAgeFromDOB,
  calculateNextPaymentDate,
  DateOfAnnuityPayments,
  DateOfAnnuityPaymentsEnum,
  FrequencyOptions,
  TypeOfExpectancyForAnnuitization,
} from "./DistributionConstantsAndFunctions";
const HeadingAndTextComponent = ({
  headingText = "",
  contentText = "",
  style = {},
}) => (
  <div style={{ marginTop: "20px", ...style }}>
    <div className="body_color">{headingText}</div>
    <div className="textWord mt-2">{contentText}</div>
  </div>
);

function AnnutizationDetails(props) {
  const {
    fields,
    withdrawalRequestId,
    values,
    setValues,
    className = "",
    style = {},
    handleChange,
    setFieldValue,
    vestBalance,
    periodicPaymentCalculationDetails,
    employeeDetails,
    selectedWithdrawalPlanSetUp,
    employeePlans,
    selectedPlan,
    ...rest
  } = props;
  const paymentFrequencyOptions = toOptionValuesFromMapper(
    DateOfAnnuityPayments
  ).filter((_) =>
    selectedWithdrawalPlanSetUp?.dateOfAnnuityPayments?.includes(_.value)
  );

  const onDaySelected = (fieldName, value) => {
    setFieldValue(fieldName, value);
  };

  const nextRepaymentDateDefault = calculateNextPaymentDate(
    selectedWithdrawalPlanSetUp
  );

  const isEmployeeMarried = employeeDetails.maritalStatus == "M";

  const specificTenureOptions = toOptionValuesFromMapper(
    TypeOfExpectancyForAnnuitization
  ).filter((_) => isEmployeeMarried || _.value !== 1);

  const annutizationData = periodicPaymentCalculationDetails.find(
    (_) =>
      _.periodicPaymentType == "Annuitization" &&
      ([null, undefined, ""].includes(values[fields.typeOfExpectancy]) ||
        values[fields.typeOfExpectancy] === _.lifeExpectancyType) &&
      ([null, undefined, ""].includes(values[fields.frequency]) ||
        values[fields.frequency] === _.frequencyType)
  );
  console.log(
    "annutizationData",
    annutizationData,
    periodicPaymentCalculationDetails,
    values
  );

  const grossAmountDetail = annutizationData?.grossAmount;

  const assumedGrowth = employeePlans[selectedPlan].withdrawals.filter(
    (_) => _.withDrawalType === values[fields.withdrawalType]
  )[0]?.interestRate;

  const disbursementFrequencyOptions = toOptionValuesFromMapper(
    OPTIONS_DATA_MAPPER.PAYROLLFREQUENCY_TYPE
  ).filter((_) => [4, 5, 6, 7].includes(_.value));

  return (
    <div style={{ ...style }} className={className}>
      <div className="heading-div">
        {values[fields.periodicPaymentType] ===
        OPTIONS_DATA_MAPPER.PERIODIC_PAYMENT_OPTIONS_ENUM.SpecificDollar
          ? "Specific Dollar"
          : "Annutization Details"}
      </div>
      <div className="basic-details-card">
        <div className="d-flex w-100 justify-content-between">
          <HeadingAndTextComponent
            headingText="Total Available Amount"
            contentText={`$ ${parseInt(
              values[fields.netAmountRequested]
            ).toFixed(2)}`}
          />
          {values[fields.periodicPaymentType] ===
            OPTIONS_DATA_MAPPER.PERIODIC_PAYMENT_OPTIONS_ENUM
              .AnnuitizationMethod && (
            <>
              <HeadingAndTextComponent
                headingText="Assumed Growth"
                contentText={`${assumedGrowth} % per annum`}
              />
              {values[fields.dateOfAnnuityPayments] ===
                DateOfAnnuityPaymentsEnum.FixedDate && (
                <HeadingAndTextComponent
                  headingText="Withdrawal Amount"
                  contentText={`$ ${grossAmountDetail?.toFixed(2)} / ${
                    OPTIONS_DATA_MAPPER.PAYROLLFREQUENCY_TYPE[
                      selectedWithdrawalPlanSetUp?.paymentFrequencyApplicable
                    ]
                  } `}
                  style={{
                    marginTop: "auto",
                    background: "#F6F6F6",
                    padding: "10px",
                  }}
                />
              )}
              {values[fields.dateOfAnnuityPayments] ===
                DateOfAnnuityPaymentsEnum.PartipicantSelected &&
                values[fields.frequency] && (
                  <HeadingAndTextComponent
                    headingText="Withdrawal Amount"
                    contentText={`$ ${grossAmountDetail.toFixed(2)} / ${
                      OPTIONS_DATA_MAPPER.PAYROLLFREQUENCY_TYPE[
                        values[fields.frequency]
                      ]
                    }`}
                    style={{
                      marginTop: "auto",
                      background: "#F6F6F6",
                      padding: "10px",
                    }}
                  />
                )}
            </>
          )}
        </div>

        {values[fields.periodicPaymentType] ===
        OPTIONS_DATA_MAPPER.PERIODIC_PAYMENT_OPTIONS_ENUM.SpecificDollar ? (
          <>
            <p className="fw-400 ft-14 mt-25 Dark-Grey-Color">
              Net periodic payment amount
            </p>
            <Field
              isRequired
              name={fields.netPeriodicPaymentAmount}
              size="sm"
              selectedValue={values[fields.netPeriodicPaymentAmount]}
              onChange={handleChange}
              //disabled={isEdit && !isSave}
              validate={(value) => {
                return [undefined, null, ""].includes(value)
                  ? "Required"
                  : undefined;
              }}
              component={FieldInputDollar}
            />
          </>
        ) : (
          <>
            <p className="body_color mt-25">IRS Table</p>
            <Field
              size="md"
              name={fields.typeOfExpectancy}
              value={values[fields.typeOfExpectancy]}
              options={specificTenureOptions}
              disabled={!isEmpty(withdrawalRequestId)}
              validate={(value) => {
                return [undefined, null, ""].includes(value)
                  ? "Required"
                  : undefined;
              }}
              popupContent={
                <SearchableList
                  label="IRS Table"
                  options={specificTenureOptions}
                  selectedValue={values[fields.typeOfExpectancy]}
                  onSelect={(value) => {
                    let updatedValues = clearFieldValues({
                      values,
                      fieldsToClear: [
                        fields.dateOfAnnuityPayments,
                        fields.frequency,
                        fields.nextRepaymentDate,
                      ],
                    });
                    updatedValues[fields.typeOfExpectancy] = value;
                    setValues(updatedValues);
                  }}
                />
              }
              component={FieldDropSide}
            />
            {(values[fields.typeOfExpectancy] === 0 ||
              values[fields.typeOfExpectancy] === 1) && (
              <>
                <HeadingAndTextComponent
                  headingText="Participant Life Expectency"
                  contentText={annutizationData?.lifeExpectancy}
                  style={{ marginTop: "auto" }}
                />

                <HeadingAndTextComponent
                  headingText="Participant Date Of Birth"
                  contentText={moment(employeeDetails?.birthDate).format(
                    "MM/DD/YYYY"
                  )}
                />

                <HeadingAndTextComponent
                  headingText="Participant Current Age"
                  contentText={calculateAgeFromDOB(employeeDetails?.birthDate)}
                />

                {values[fields.typeOfExpectancy] === 1 && (
                  <HeadingAndTextComponent
                    headingText="Beneficiary Current Age"
                    contentText={annutizationData?.spouseAge}
                  />
                )}
              </>
            )}
          </>
        )}

        <p className="body_color mt-20">Payment Frequency</p>
        <Field
          isRequired
          name={fields.dateOfAnnuityPayments}
          size="sm"
          options={paymentFrequencyOptions}
          selectedValue={values[fields.dateOfAnnuityPayments]}
          onChange={(value) => {
            const tempValues = { ...values };
            tempValues[fields.dateOfAnnuityPayments] = value;
            if (value == 1) {
              tempValues[fields.frequency] =
                selectedWithdrawalPlanSetUp?.paymentFrequencyApplicable;
              tempValues[fields.nextRepaymentDate] = nextRepaymentDateDefault;
            } else {
              tempValues[fields.frequency] = null;
              tempValues[fields.nextRepaymentDate] = null;
            }
            setValues(tempValues);
          }}
          validate={(value) => {
            return [undefined, null, ""].includes(value)
              ? "Required"
              : undefined;
          }}
          component={FieldButtonGroup}
        />

        {values[fields.dateOfAnnuityPayments] ===
          DateOfAnnuityPaymentsEnum.FixedDate && (
          <>
            <HeadingAndTextComponent
              headingText="Disbursement Frequency"
              contentText={
                OPTIONS_DATA_MAPPER.PAYROLLFREQUENCY_TYPE[
                  selectedWithdrawalPlanSetUp?.paymentFrequencyApplicable
                ]
              }
            />

            <HeadingAndTextComponent
              headingText="Date"
              contentText={calculateNextPaymentDate(
                selectedWithdrawalPlanSetUp
              )}
            />
          </>
        )}

        {values[fields.dateOfAnnuityPayments] ===
          DateOfAnnuityPaymentsEnum.PartipicantSelected && (
          <>
            <Field
              size="md"
              name={fields.frequency}
              isRequired
              value={values[fields.frequency]}
              options={disbursementFrequencyOptions}
              placeholder="Disbursement frequency"
              label="Disbursement frequency"
              disabled={!isEmpty(withdrawalRequestId)}
              validate={(value) => {
                return [undefined, null, ""].includes(value)
                  ? "Required"
                  : undefined;
              }}
              popupContent={
                <SearchableList
                  label="Disbursement frequency"
                  options={disbursementFrequencyOptions}
                  selectedValue={values[fields.frequency]}
                  onSelect={(value) => {
                    setFieldValue(fields.frequency, value);
                  }}
                />
              }
              component={FieldDropSide}
            />

            <Field
              size="sm"
              label="Date"
              isRequired
              name={fields.nextRepaymentDate}
              value={usDateFormat(values[fields.nextRepaymentDate])}
              isDatePicker
              onClear={() => setFieldValue(fields.nextRepaymentDate, "")}
              validate={(value) =>
                ["", undefined, null, "Select One"].includes(value) &&
                isEmpty(values[fields.nextRepaymentDate])
                  ? "Required"
                  : null
              }
              popupContent={
                <DatePicker
                  onDayClick={(value) =>
                    onDaySelected(fields.nextRepaymentDate, value)
                  }
                  value={usDateFormat(values[fields.nextRepaymentDate])}
                />
              }
              component={FieldDropSide}
            />
          </>
        )}
      </div>
    </div>
  );
}

export default AnnutizationDetails;
